$(function () {

    // accessibility for nav dropdowns
    /** Class representing a flyout menu. */
    class FlyoutMenu {
        /**
         * Create a flyout menu
         * @param {string} id - The id name of the menu's wrapper
         */
        constructor(id) {
            this.id = id;
            this.menuItems = [];
            let menuItems = document.getElementById(id).getElementsByClassName('-dropdown');
            Array.prototype.forEach.call(menuItems, (menuItem) => {
                this.menuItems.push(new FlyoutMenuItem(menuItem));
            });
            this.menuItems.forEach((menuItem) => {
                ['mouseover', 'mouseout'].forEach( (listener) => {
                    menuItem.el.addEventListener(listener, this.toggle.bind(this, menuItem));
                });
                menuItem.topLevelLink.addEventListener('focus', this.closeAll.bind(this, menuItem));
                menuItem.btn.addEventListener('focus', (event) => {
                    this.closeAll(menuItem);
                    event.preventDefault();
                }, this);
                menuItem.btn.addEventListener("click",  (event) => {
                    this.toggle(menuItem);
                    event.preventDefault();
                }, this);
            })
        }
        /**
         * Toggle the current menu item
         * @param {string} currentItem - The menu item that is being triggered
         */
        toggle(currentItem) {
            this.closeAll(currentItem);
            if (currentItem.el.classList.contains('-active')){
                currentItem.close()
            } else {
                currentItem.open();
            }
        }
        /**
         * Closes all other menu items except the current one
         * @param {string} currentItem - The menu item that is being triggered
         */
        closeAll(currentItem) {
            this.menuItems.forEach((menuItem) => {
                if (menuItem === currentItem) return;
                menuItem.close();
            });
            // document.addEventListener('keydown', function(event){
            //     if(event.key === "Escape"){
            //         if (menuItem === currentItem) return;
            //         menuItem.close();
            //     }
            // });
        }
    }
    /** Class representing a flyout menu item. */
    class FlyoutMenuItem {
        constructor(menuItem) {
            this.el = menuItem;
            this.btn = document.createElement("BUTTON");
            this.btn.className = "navPrimary__arrow";
            this.topLevelLink = this.el.getElementsByTagName('a')[0];
            this.btn.title = "show submenu";
            // this.btnLabel = document.createElement("SPAN");
            // this.btnLabel.className = "sr-only";
            // this.btnLabel.prop('title', 'show submenu');
            // this.btn.appendChild(this.btnLabel);
            this.topLevelLink.appendChild(this.btn);
        }
        /** Opens a menu item */
        open() {
            this.el.classList.add("-active");
            this.topLevelLink.setAttribute('aria-expanded', "true");
            this.btn.title = "hide submenu";
        }
        /** Closes a menu item */
        close() {
            this.el.classList.remove("-active");
            this.topLevelLink.setAttribute('aria-expanded', "false");
            this.btn.title = "show submenu";
        }
    }

    if (document.getElementById('flyoutnav')) {
        let mainMenu = new FlyoutMenu("flyoutnav");
    }

    

    // mobile menu toggle and open function
    var $toggleButton = $('.menuToggle'),
    $menuWrap = $('.mobileMenu__wrap'),
    $menuItem = $('.mobileMenu__item'),
    $overlay = $('.mobileMenu__overlay'),
    $body = $('body'),
    $link = $('.mobileMenu__link');

    $toggleButton.on('click touch', function () {
        $(this).toggleClass('-open');
        $menuWrap.toggleClass('-show');
        $overlay.toggleClass('-active');
        $body.toggleClass('-menuOpen');
    });
    $link.on('click touch', function () {
        $toggleButton.removeClass('-open');
        $menuWrap.removeClass('-show');
        $overlay.removeClass('-active');
        $body.removeClass('-menuOpen');
    });

    // mobile menu subnav expand and collapse
    const triggers = Array.from(document.querySelectorAll('[data-toggle="collapse"]'));

    triggers.forEach(trigger => {
        trigger.addEventListener('click', (ev) => {
            const elm = ev.target;
            if (triggers.includes(elm)) {
                const selector = elm.getAttribute('data-target');
                collapse(selector, 'toggle');
            }
            trigger.classList.toggle('-show');
            trigger.parentElement.classList.toggle('-show');
        }, false);
    });
    const fnmap = {
        'toggle': 'toggle',
        'show': 'add',
        'hide': 'remove'
    };
    const collapse = (selector, cmd) => {
        const targets = Array.from(document.querySelectorAll(selector));
        targets.forEach(target => {
            target.classList[fnmap[cmd]]('-show');
        });
    }
});